import React from "react";

const NavTab = ({ tab, onClick, selected, isNavBar, pendingCount }) => {
  const highlight = () => {
    let classList = "nav-link text-black ps-0 text-capitalize ";
    classList += selected ? "fw-bold" : "";
    return classList;
  };

  const pageLink = () =>
    isNavBar ? (
      <a className={highlight()} href={tab}>
        {tab}
      </a>
    ) : (
      <a className={highlight()}>{tab === 'pending' && pendingCount > 0 ? `${tab} (${pendingCount})` : tab}</a>
    );

  return (
    <>
      <li className="nav-item" onClick={onClick}>
        {pageLink()}
      </li>
    </>
  );
};

export default NavTab;
